<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="labelCorrectionData"
      style="width: 100.1%;"
    >
      <!-- 删除 -->
      <template slot-scope="{ row, index }" slot="operations">
        <Button
          type="warning"
          size="small"
          v-hasPermission="['labelManagement:tag:correct_edit']"
          @click="addOrUpdateHandle(row.id, row)"
          >{{ $t('alarms.common.edit') }}</Button
        >
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            v-hasPermission="['labelManagement:tag:correct_delete']"
            @click="delModel = true"
            >{{ $t("common.del") }}</Button
          >
        </span>
      </template>
    </Table>
    <!-- 删除 -->
    <Modal v-model="delModel" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>{{ $t('tag.labelCorrection.sureDeleteRecord') }}</p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="delLoading"
          @click="removeLabelCorrection()"
          >{{ $t("common.del") }}</Button
        >
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
    <!-- 弹窗，新增/编辑 -->
    <add-or-update-label-correction
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
    ></add-or-update-label-correction>
  </div>
</template>
<script>
import { getCookie } from "../../../../../utils/cookieUtil.js";
import AddOrUpdateLabelCorrection from "./AddOrUpdateLabelCorrection";
var tableLabelCorrectionVue = {};
export default {
  name: "TableLabelCorrection",
  components: {
    AddOrUpdateLabelCorrection
  },
  data() {
    return {
      company: getCookie(global.companyId),
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      addOrUpdateVisible: false,
      delModel: false,
      delLoading: false,
      columns: [
        {
          title: this.$t('tag.labelCorrection.standardTagName'),
          key: "standardTagKeyName"
        },
        {
          title: this.$t('tag.labelCorrection.standardTagCorrectedValue'),
          key: "standardTagValue"
        },
        {
          title: this.$t('tag.labelCorrection.standardTagAssociatedValues'),
          key: "correctStandardTagValues",
          render: (h, params) => {
            return h("div", {
              domProps: {
                innerHTML: params.row.correctStandardTagValues
              }
            });
          }
        },
        {
          title: this.$t('common.operation'),
          slot: "operations"
        }
      ],
      labelCorrectionData: []
    };
  },
  beforeCreate: function() {
    tableLabelCorrectionVue = this;
  },
  mounted: function() {
    eventBus.$on("getDataLabelCorrection", () => {
      tableLabelCorrectionVue.getData();
    });
    tableLabelCorrectionVue.getData();
  },
  methods: {
    showAll: function() {
      tableLabelCorrectionVue.getData();
    },
    // 分页显示数据
    getData: function() {
      eventBus.$on("companyId", function(val) {
        tableLabelCorrectionVue.companyId = val;
      });
      // 列表分页
      this.$api.correctStandardTagValueConfiguration
        .pagingQuery({
          companyId:
            tableLabelCorrectionVue.companyId == null ||
            tableLabelCorrectionVue.companyId == "" ||
            tableLabelCorrectionVue.companyId == undefined
              ? this.company
              : tableLabelCorrectionVue.companyId,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.labelCorrectionData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableLabelCorrectionVue.getData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableLabelCorrectionVue.getData();
    },
    /**
     * 编辑
     */
    addOrUpdateHandle: function(id, row) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id, row);
      });
    },
    /**************************删除****************************/
    // 删除
    doDelete: function(index) {
      this.lineIndex = index;
    },
    removeLabelCorrection: function() {
      let lineIndex = this.lineIndex;
      // 删除
      this.$api.correctStandardTagValueConfiguration
        .delete("id", this.labelCorrectionData[lineIndex].id)
        .then(res => {
          this.delLoading = true;
          setTimeout(() => {
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableLabelCorrectionVue.getData();
            this.delLoading = false;
            this.delModel = false;
            this.$Message.success(this.$t('common.deleteSuccess'));
          }, 1000);
        });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/label_management/tag_management/label_correction/TableLabelCorrection.vue